import * as React from 'react'
import { RouteComponentProps } from 'react-router-dom'
import classes from './About.module.scss'

const About: React.FC<RouteComponentProps<{ stub?: any }>> = () => (
  <div className={classes.root}>
    <h2>Om vår statistik</h2>
    <p>
      Varje år sammanställer vi statistik över hur mycket som pantas i Sverige
      och därmed kan återvinnas till nya burkar och flaskor.
    </p>
    <h4>Årsstatistik – totalt antal pantade förpackningar</h4>
    <p>
      Årsstatistiken består av antalet pantade och därigenom återtagna
      förpackningar. Dessa baseras primärt på streckkodsavläsning i pantautomat
      eller avläsning i vår fabrik alternativt vägning av material eller
      schablon.
    </p>
    <p>
      Under 2025 samlades 3 001 500 000 förpackningar in. Returpack väljer att
      avrunda till 3 miljarder förpackningar. Pantstatistiken är baserad på det
      totala antalet pantade förpackningar.
    </p>
    <p>
      Antalet pantade förpackningar kan hanteras på riks-, läns- och kommunnivå.
      Du kan jämföra län eller kommuner med varandra genom att klicka i rutan
      för de val du vill göra. Du kan även välja olika år för att se statistik
      bakåt i tiden.
    </p>
    <h4>Antal pantade förpackningar per person</h4>
    <p>
      Antalet pantade förpackningar per person baseras på det totala antalet
      pantade förpackningar genom den befolkningsmängd som det valda området
      (riks, län eller kommun) har. Befolkningssiffrorna hämtas från Statistiska
      Centralbyrån (SCB) i samband med att de släpper sin statistik över senaste
      helår.
    </p>
    <h4>Pantningsgrad</h4>
    <p>
      Pantningsgrad beräknas som antalet återtagna förpackningar dividerat med
      antalet sålda förpackningar. Antalet återtagna förpackningar baseras
      primärt på streckkodsavläsning i pantautomat eller avläsning i vår fabrik
      alternativt vägning av material eller schablon. Antalet sålda
      förpackningar baseras på rapporterad försäljning från producenter och
      importörer. Vid beräkning av pantningsgrad för metallförpackningar
      inkluderas även den mängd införselburk (privat importerad) som samlats in
      och återvinns via oss i antalet återtagna förpackningar.
    </p>
    <p>
      Pantningsgraden visas endast på totalnivå och går inte att se på läns-
      eller kommunnivå.
    </p>
  </div>
)

export default About
